import * as React from 'react';

export const intersectionSpace = (
	<hr style={{ height: '140px', color: 'transparent', borderColor: 'transparent' }}></hr>
);
export const line = <hr style={{ border: '2px solid black', width: '100%' }}></hr>;

export const scrollToRef = (ref) => window.scrollTo({ left: 0, top: ref.current.offsetTop, behavior: 'smooth' });
